module.exports = __webpack_public_path__ + "static/media/aboutUsLogo.ced26618.svg";